(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Aparición al hacer scroll ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.ac-reveal:not(.ac-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('ac-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('ac-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -30px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Página de producto ---------- */
  function initProducto() {
    document.querySelectorAll('[data-ac-producto]').forEach(function (root) {
      if (root.dataset.acListo) return;
      root.dataset.acListo = '1';

      // Galería
      var principal = root.querySelector('[data-ac-principal]');
      root.querySelectorAll('[data-ac-mini]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!principal) return;
          principal.style.opacity = '0';
          setTimeout(function () {
            principal.src = btn.getAttribute('data-src');
            principal.srcset = btn.getAttribute('data-srcset') || '';
            principal.alt = btn.getAttribute('data-alt') || '';
            principal.style.opacity = '1';
          }, 160);
          root.querySelectorAll('[data-ac-mini]').forEach(function (b) { b.classList.remove('is-activa'); });
          btn.classList.add('is-activa');
        });
      });

      // Ofertas → fija la cantidad que lee el formulario de pago contra entrega
      var ofertas = root.querySelectorAll('[data-ac-oferta]');
      function fijarCantidad(q) {
        document.querySelectorAll('form[action*="/cart/add"] input[name="quantity"]').forEach(function (inp) {
          inp.value = q;
          inp.dispatchEvent(new Event('input', { bubbles: true }));
          inp.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }
      ofertas.forEach(function (o) {
        var radio = o.querySelector('input');
        radio.addEventListener('change', function () {
          ofertas.forEach(function (x) { x.classList.toggle('is-activa', x === o); });
          fijarCantidad(o.getAttribute('data-cantidad'));
        });
      });
      var marcada = root.querySelector('[data-ac-oferta] input:checked');
      if (marcada) fijarCantidad(marcada.closest('[data-ac-oferta]').getAttribute('data-cantidad'));
    });
  }

  /* ---------- Enlaces internos con desplazamiento suave ---------- */
  function initAnclas() {
    document.querySelectorAll('a[href^="#"][data-ac-ancla]').forEach(function (a) {
      if (a.dataset.acListo) return;
      a.dataset.acListo = '1';
      a.addEventListener('click', function (e) {
        var destino = document.querySelector(a.getAttribute('href'));
        if (!destino) return;
        e.preventDefault();
        destino.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      });
    });
  }

  /* ---------- Botón de pago contra entrega con el color de la marca ---------- */
  function initBotonPago() {
    if (!document.querySelector('[data-ac-producto]')) return;
    var marino = getComputedStyle(document.documentElement).getPropertyValue('--ac-marino').trim() || '#0F2A44';
    function pintar() {
      document.querySelectorAll('.ac-prod__apps .es-popup-button-product, .es-sticky-product').forEach(function (b) {
        if (b.dataset.acPintado) return;
        b.dataset.acPintado = '1';
        b.style.setProperty('background', marino, 'important');
        b.style.setProperty('border-color', marino, 'important');
        b.style.setProperty('border-radius', '14px', 'important');
      });
    }
    pintar();
    var mo = new MutationObserver(pintar);
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 15000);
  }

  function init() { initReveal(); initProducto(); initAnclas(); initBotonPago(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
